import React, { useEffect, useState } from 'react';
import HomeFooter from "components/Footer/HomeFooter.js";
import {colors} from '../components/Theme/WebTheme';
import Hero from "../components/Hero";
import Section from "../components/Section";

import { useSelector } from "react-redux";


export default function LandingPage(props) {

  const auth = useSelector(state => state.auth);

  const { ...rest } = props;
  console.log("Rest props in landing page:", rest);

  const [role, setRole] = useState();

  useEffect(() => {
    if (auth && auth.profile) {
      if(auth.profile.uid){
        let role = auth.profile.usertype;
        setRole(role);
      }
    }
  }, [auth]);

  return (
    <div>
      <Hero role={role}/>
      <Section role={role} color={colors}/>
      {/* <Download /> */}
      <HomeFooter />
    </div>
  );
}
